<template>
  <div class="bg-card wow fadeInDown">
    <div class="zy-container">
      <div class="card">
        <div class="card-col first-col">
          <div class="card-data " :class="{'card-data-show':firstIndex==0}">
            <div class="col-title">全网唯一支持高级美颜直播</div>
            <div class="col-desc">
              可轻松实现多种业务场景下客户的实时美颜需
            </div>
          </div>
          <div class="card-data" style="padding-top: 0" :class="{'card-data-show':firstIndex==1}">
            <div class="col-title">多维数据统计，量化直播效果</div>
            <div class="col-desc">
              全网唯一支持高级美颜直播（美白，磨皮，瘦脸，瘦身等上百种自定义美颜，数十种动态贴纸，上百种动态礼物等
            </div>
            <el-image :src="require('@/assets/images/index/live-video/img7.png')" class="many-dimensions"/>
          </div>
          <div class="tile-button-wrapper">
            <el-image :src="require('@/assets/images/index/live-video/img6.png')" class="add-icon " :class="{'tile-overlay':firstIndex==1}" @click="toggleHandler"/>
          </div>
        </div>
        <div class="card-col">
          <div class="card-head">
            <div class="card-title">
              满足直播、短视频等多种导购场景
            </div>
            <div class="type-raw">
              <div class="type-widget">
                <div class="type-col" v-for="(item,index) in typeData" :key="index" :class="{'type-col-active':typeIndex===index}" @click="typeHandler(index)">{{ item }}</div>
              </div>
            </div>
            <el-image :src="require('@/assets/images/index/live-video/img5.png')" class="img-icon" v-show="typeIndex===0"/>
            <el-image :src="require('@/assets/images/index/live-video/img9.png')" class="img-icon" v-show="typeIndex===1"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {WOW} from "wowjs";

export default {
  props: {},
  components: {},
  data() {
    return {
      typeData: [
        '直播导购',
        '段视频导购',
      ],
      typeIndex: 0,
      firstIndex: 0,
    }
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init()
    })
  },
  methods: {
    typeHandler(index) {
      this.typeIndex = index
    },
    toggleHandler() {
      this.firstIndex = this.firstIndex == 0 ? 1 : 0
    }
  }
}
</script>

<style scoped lang="scss">
.bg-card {
  background: #F8F8FC;
  padding-top: 38px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.card {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .card-col {
    padding-top: 43px;
    padding-bottom: 43px;
    flex: 0 0 auto;
    width: 49%;
    margin-bottom: 2%;
    background: #FFFFFF;
    transition: opacity .5s ease-in-out;
    border-radius: 30px;
    box-sizing: border-box;
  }

  .first-col {
    background: #353FDC;
    color: #fff;
    position: relative;
  }

  .tile-button-wrapper {
    position: absolute;
    right: 8px;
    bottom: 6px;
  }

  .add-icon {
    width: 73px;
    height: 73px;
    cursor: pointer;
    transition: transform .5s cubic-bezier(0.66, 0, 0.2, 1);
  }

  .tile-overlay {
    transform: rotate(45deg);
    transition: transform .5s ease-in-out
  }

  .card-data {
    padding: 33% 8% 0;
    opacity: 0;
    transition: opacity .9s ease-in-out;
    visibility: hidden;
    display: none;
  }

  .card-data-show {
    display: block;
    opacity: 1;
    visibility: visible;
    animation: fadeIn 1.8s ease-in-out;
  }


  @keyframes fadeIn {
    0% {
      opacity: 0;
      visibility: hidden;
    }
    50% {
      opacity: 1;
      visibility: visible;
    }
    100% {
      opacity: 1;
      visibility: visible;
    }
  }

  .many-dimensions {
    position: absolute;
    bottom: 0;
    width: 78%;
    left: 50%;
    transform: translateX(-50%);
  }

  .content-overlay {
    opacity: 1;
    visibility: visible;
  }

  .col-title {
    font-size: 29px;
    font-weight: 600;
    color: #FFFFFF;
    position: relative;
    padding-bottom: 15px;
    margin-bottom: 15px;
  }

  .col-title::after {
    content: "";
    display: block;
    width: 40px;
    height: 4px;
    position: absolute;
    bottom: 0;
    left: 0%;
    background: linear-gradient(137deg, #E266FF 0%, #00FCFF 100%);
    border-radius: 4px;
  }

  .col-desc {
    font-size: 20px;
    font-weight: 400;
    color: #FFFFFF;
  }

}


.card-head {
  width: 88%;
  margin: 0 auto;

  .card-title {
    font-size: 29px;
    font-weight: 600;
    color: #333333;
    text-align: center;
    position: relative;
    padding-bottom: 16px;
  }


  .card-title:after {
    content: '';
    display: block;
    width: 40px;
    height: 4px;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    background: linear-gradient(137deg, #E266FF 0%, #00FCFF 100%);
    border-radius: 4px;
  }

  .card-func-desc {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 27px;
    line-height: 33px;
  }


  .type-raw {
    display: flex;
    justify-content: center;
    margin-top: 28px;
  }

  .type-widget {
    display: flex;
    align-items: center;
  }

  .type-col {
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #666666;
    cursor: pointer;
    padding: 5px 9px 4px;
    background: #fff;
  }

  .type-col:nth-child(1) {
    border-radius: 3px 0px 0px 3px;
    border: 1px solid #DFDBFF;
  }

  .type-col:nth-child(2) {
    border-radius: 0px 3px 3px 0px;
    border: 1px solid #DFDBFF;
    border-left-width: 0px;
  }

  .type-col-active {
    font-weight: 400;
    color: #353FDC;
    background: #F3EDFF;
    border-color: #353FDC;
  }
}

.img-icon {
  display: block;
  margin: 0 auto;
  width: 90%;
  height: auto;
  animation: fadeIn 1.8s ease-in-out;
}


</style>
